import Vue from "vue";
import MyLoading from "./Load.vue";

// 实例化组件， 将组件的挂载点设置在自己创建的div
const CreatLoading = Vue.extend(MyLoading);
const instance = new CreatLoading({
  el: document.createElement("div"),
});
// 添加自定义属性
instance.show = false;
// 创建一个$Loading的属性添加到Vue
const loading = {
  show() {
    instance.show = true;
    document.body.appendChild(instance.$el);
  },
  hide() {
    instance.show = false;
  },
};
export default {
  // 使用install来传输
  install() {
    if (!Vue.$loading) {
      Vue.$loading = loading;
    }
    // 往所有组件中混入$loading
    Vue.mixin({
      created() {
        this.$loading = Vue.$loading;
      },
    });
  },
};
